export enum LogStatus {
	Info = 'Info',
	Warn = 'Warn',
	Error = 'Error',
}

export type LogType = string;

export interface LogDTO {
	_id: string;
	author?: string | null;
	authorId?: string | null;
	authorName?: string | null;
	log?: string | null;
	logType?: LogType | null;
	typeTranslation?: string | null;
	status?: LogStatus | string | null;
	stackTrace?: string | null;
	browser?: string | null;
	createdAt?: string | null;
}

export interface LogPaginatedResponse {
	docs: LogDTO[];
	totalDocs: number;
	limit: number;
	page: number;
	totalPages: number;
	pagingCounter: number;
	hasPrevPage: boolean;
	hasNextPage: boolean;
	prevPage?: number | null;
	nextPage?: number | null;
}

export interface FindAllLogQuery {
	limit?: number;
	page?: number;
	startDate?: string;
	endDate?: string;
	search?: string;
	type?: string;
	status?: LogStatus | string;
	authorId?: string;
	enabled?: boolean;
}

export interface LogView {
	id: string;
	tipo: string;
	tipoTecnico: string;
	acao: string;
	usuario: string;
	authorId?: string;
	timestamp: string;
	status: LogStatus;
	statusLabel: string;
	navegador?: string;
	stacktrace?: string;
}

export interface LogAuthorFilterUser {
	id: string;
	name: string;
	email: string;
	profileImage?: string | null;
}

export const LOG_STATUS_LABELS: Record<LogStatus, string> = {
	[LogStatus.Info]: 'Informação',
	[LogStatus.Warn]: 'Aviso',
	[LogStatus.Error]: 'Erro',
};
